import { css } from 'linaria';

export default function loadCss() {
  return css`
    :global(html) {
      @import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;600;700&display=swap');
    }
  `;
}
